import {
    List as UiList,
    ListItemButton as UiListItemButton,
    Tooltip as UiTooltip,
    Typography,
} from "@mui/material"
import { styled } from "@mui/material/styles"

import { KeyboardArrowUpIcon } from "@l2r-front/l2r-icons"

export const ListItemButton = styled(UiListItemButton, {
    shouldForwardProp: (prop) => prop !== "isDisabled" && prop !== "isSelected",
})(({ isDisabled, isSelected, theme }) => {

    const border = isSelected ? `2px solid ${theme.palette["border/border-primary"].main}`
        : isDisabled ? `1px solid ${theme.palette["surfaces/surface-disabled"].main}`
            : `1px solid ${theme.palette["component/input/enabled/border"].main}`

    return ({
        "&:hover": {
            backgroundColor: isDisabled ? `${theme.palette["surfaces/surface-disabled"].main} !important`
                : `${theme.palette["surfaces/surface-variation"].main} !important`,
        },
        "& > span": {
            marginLeft: theme.spacing(6),
        },
        "&:active": {
            backgroundColor: isDisabled && `${theme.palette["surfaces/surface-disabled"].main} !important`,
        },
        backgroundColor: isDisabled ? `${theme.palette["surfaces/surface-disabled"].main} !important`
            : `${theme.palette["surfaces/surface-primary"].main} !important`,
        border: border,
        borderRadius: 12,
        boxSizing: "border-box",
        color: isDisabled && theme.palette["action/disabled"].main,
        cursor: isDisabled ? "default" : "pointer",
        display: "flex",
        fontSize: isSelected ? theme.typography["H3"].fontSize : theme.typography["Regular"].fontSize,
        fontWeight: isSelected ? theme.typography["H3"].fontWeight : theme.typography["Regular"].fontWeight,
        justifyContent: "space-between",
        height: 46,
        marginBottom: theme.spacing(3),
        opacity: isDisabled && "1 !important",
        padding: theme.spacing(1, 4),
        width: "100%",
    })
})

export const Label = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "disabled" && prop !== "selected" && prop !== "paddingLeft",
})(({ disabled, paddingLeft, selected, theme }) => ({
    color: disabled && theme.palette["action/disabled"].main,
    marginLeft: paddingLeft && "8%",
    marginRight: "auto",
    fontSize: selected ? theme.typography["H3"].fontSize : theme.typography["Regular"].fontSize,
    fontWeight: selected ? theme.typography["H3"].fontWeight : theme.typography["Regular"].fontWeight,
}))
export const Tooltip = styled(UiTooltip)(() => ({
    marginLeft: "auto",
    marginRight: "6%",
}))

export const List = styled(UiList)(({ theme }) => ({
    marginLeft: theme.spacing(6),
}))

export const InfoItemButton = styled(ListItemButton)(({ selected, theme }) => ({
    border: `2px solid ${selected ? theme.palette["cta-bg/cta-bg-primary"].main : theme.palette["component/input/enabled/border"].main}`,
    height: 46,
    padding: theme.spacing(1, 4),

    "& > p": {
        margin: 0,
    },
}))

export const ArrowIcon = styled(KeyboardArrowUpIcon, {
    shouldForwardProp: (prop) => prop !== "isOpen",
})(({ isOpen, theme }) => ({
    color: theme.palette["objects/object-black"].main,
    marginLeft: theme.spacing(3),
    transform: !isOpen && "rotate(180deg)",
}))